import React, { FunctionComponent, useState } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import {
  FullHeightWrapper,
  BackgroundWrapper,
  SubHeader,
  SubHeaderMenuWrapper,
  SubHeaderMenuItems,
  SubHeaderTitle,
} from './Skeleton.styles';
import HamburgerMenu from './HamburgerMenu';

const Skeleton: FunctionComponent = ({ children }) => (
  <FullHeightWrapper>
    <BackgroundWrapper>
      <Header />
      {children}
    </BackgroundWrapper>
    <Footer />
  </FullHeightWrapper>
);

const SubHeaderMenu: FunctionComponent = ({ children }) => {
  const [isMenuOpen, toggleMenu] = useState(false);
  return (
    <SubHeaderMenuWrapper>
      <HamburgerMenu isOpen={isMenuOpen} toggle={toggleMenu} />
      <SubHeaderMenuItems isVisible={isMenuOpen}>{children}</SubHeaderMenuItems>
    </SubHeaderMenuWrapper>
  );
};

export { Skeleton, SubHeader, SubHeaderMenu, SubHeaderTitle };
